import { useContext, useEffect, useState } from "react";
import "./index.scss";
import {
  AppText,
  Button,
  CustomContainer,
  FlexColumn,
  FlexRow,
  FormGroup,
  FormGroupsWrapper,
  FormGroupWithIcon,
  RoundImageContainer,
} from "src/style";
import utility from "src/utils/utility";
import helpers from "src/utils/helpers";
import { Header, Select } from "src/component";
import UserContext from "src/provider/state-manager/userProvider";
import {
  getClassList,
  getIndex,
  typeGender,
  typeMember,
} from "src/utils/helpers";
import { BsHouseDoorFill } from "react-icons/bs";
import { FaUser } from "react-icons/fa";
import { HiMail } from "react-icons/hi";
import { MdPhoneInTalk } from "react-icons/md";
import Pic from "src/assets/img/32.png";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import ApiContext from "src/provider/API/call-service";
import { useNavigate } from "react-router-dom";

const EditProfile: React.FC = () => {
  const { user } = useContext(UserContext);
  const { API } = useContext(ApiContext);
  const {
    info: { editUser },
    info,
    setSubmitEditUser,
  } = useContext(AppInfoContext);
  const { visibility, setModal, notifier } = useContext(VisibilityContext);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [memberDetails, setMemberDetails] = useState({
    ...editUser,
    id: editUser._id,
    firstName: editUser?.firstName,
    surname: editUser?.surname,
    email: editUser?.email,
    memberType: editUser?.memberType,
    phoneNumber: editUser?.phoneNumber,
    address: editUser?.address,
    memberClass: editUser?.memberClass,
    gender: editUser?.gender,
  });
  const [filteredDetails, setFilteredDetails] = useState({
    firstName: editUser?.firstName,
    surname: editUser?.surname,
    email: editUser?.email,
    memberType: editUser?.memberType,
    phoneNumber: editUser?.phoneNumber,
    address: editUser?.address,
    memberClass: editUser?.memberClass,
    gender: editUser?.gender,
  });
  useEffect(() => {
    console.log(getIndex(typeGender, editUser.gender));
    console.log(getIndex(typeMember, editUser.memberType));
  }, []);

  const handleInputField = (e: any) => {
    setMemberDetails({ ...memberDetails, [e.target.name]: e.target.value });
    setFilteredDetails({ ...filteredDetails, [e.target.name]: e.target.value });
  };
  const closeModal = () => {
    setOpenModal(false);
  };
  const handleClassSelect = (key: string, value: string) => {
    setMemberDetails({ ...memberDetails, [key]: value });
    setFilteredDetails({ ...filteredDetails, [key]: value });
    console.log(value);
  };
  const handleMemberType = (key: string, value: string) => {
    setMemberDetails({ ...memberDetails, [key]: value });
    setFilteredDetails({ ...filteredDetails, [key]: value });
  };
  const handleGenderType = (key: string, value: string) => {
    setMemberDetails({ ...memberDetails, [key]: value });
    setFilteredDetails({ ...filteredDetails, [key]: value });
  };
  const handleSubmit = async () => {
    setOpenModal(false);
    await API.editProfile(memberDetails, navigate);
  };
  const handleOpenModal = () => {
    const validation = helpers.inputValidator({ ...filteredDetails });
    if (!validation.isValidated)
      return notifier.show(validation.message, "Validation Response");
    setModal({
      key: "showEditUserModal",
      value: !visibility.showEditUserModal,
    });
  };

  useEffect(() => {
    info.submitEditUser && handleSubmit();
    setSubmitEditUser(false);
  }, [info.submitEditUser]);

  return (
    <CustomContainer className="edit-member">
      <Header user={user}>
        <AppText color="#fff" textSize="3.2" fontWeight="500" leftMargin="2">
          Edit Member
        </AppText>
      </Header>

      <CustomContainer
        bgColor="#FFF5E5"
        topPadding="6"
        rightPadding="6"
        bottomPadding="6"
        leftPadding="6"
        radius="1"
        className="container"
      >
        <FlexRow gap="2">
          <RoundImageContainer size="8">
            <img src={Pic} alt="" width="100%" height="100%" />
          </RoundImageContainer>
          <FlexColumn alignItems="flex-start">
            <AppText color="#712126" textSize="2">
              Edit User
            </AppText>
            <AppText color="#374957" textSize="1.5">
              ID: {user?.profile?.regId}
            </AppText>
          </FlexColumn>
        </FlexRow>
        <div className="form-container">
          <FormGroupsWrapper gap="10" className="formGroup--wrapper">
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin="1">
                First Name
              </AppText>
              <CustomContainer>
                <FaUser className="form__input--icon" size={14} />
                <input
                  type="text"
                  className="form__input"
                  placeholder="Enter First Name"
                  name="firstName"
                  value={memberDetails?.firstName}
                  onChange={handleInputField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin="1">
                Last Name
              </AppText>
              <CustomContainer>
                <FaUser className="form__input--icon" size={14} />
                <input
                  type="text"
                  className="form__input"
                  placeholder="Enter Last Name"
                  name="surname"
                  value={memberDetails?.surname}
                  onChange={handleInputField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
          </FormGroupsWrapper>

          <FormGroupsWrapper gap="10" className="formGroup--wrapper">
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin="1">
                Email
              </AppText>
              <CustomContainer>
                <HiMail className="form__input--icon" size={16} />
                <input
                  type="email"
                  className="form__input"
                  placeholder="Enter Email"
                  name="email"
                  value={memberDetails?.email}
                  onChange={handleInputField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin="1">
                Phone Number
              </AppText>
              <CustomContainer>
                <MdPhoneInTalk className="form__input--icon" size={18} />
                <input
                  type="text"
                  className="form__input"
                  placeholder="Enter Phone number"
                  name="phoneNumber"
                  value={memberDetails?.phoneNumber}
                  onChange={handleInputField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
          </FormGroupsWrapper>

          <FormGroupsWrapper gap="10" className="formGroup--wrapper">
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <AppText color="#712126" fontWeight="500" bottomMargin="1">
                Address
              </AppText>
              <CustomContainer>
                <BsHouseDoorFill className="form__input--icon" size={16} />
                <input
                  type="text"
                  className="form__input"
                  placeholder="Enter Address"
                  name="address"
                  value={memberDetails?.address}
                  onChange={handleInputField}
                />
              </CustomContainer>
            </FormGroupWithIcon>
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <Select
                placeholder="Select User Class"
                label="Class"
                list={getClassList(info)}
                handleSelect={handleClassSelect}
                labelColor="#712126"
                labelSize="1.5"
                className="select-dropdown"
                height="20rem"
                name="memberClass"
                defaultValue={getIndex(
                  getClassList(info),
                  memberDetails.memberClass
                )}
              />
            </FormGroupWithIcon>
          </FormGroupsWrapper>
          <FormGroupsWrapper gap="10" className="formGroup--wrapper">
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <Select
                label="User Type"
                labelColor="#712126"
                placeholder="Select User Type"
                list={typeMember}
                handleSelect={handleMemberType}
                Icon={<FaUser color="#B8B8B8" />}
                labelSize="1.5"
                className="select-dropdown"
                name="memberType"
                defaultValue={getIndex(typeMember, editUser?.memberType)}
              />
            </FormGroupWithIcon>
            <FormGroupWithIcon
              bgColor="#fff"
              inputColor="#374957"
              borderColor="#8A8A8A"
              width="40"
              className="formGroup"
            >
              <Select
                label="Gender"
                labelColor="#712126"
                placeholder="Select Gender"
                list={typeGender}
                handleSelect={handleGenderType}
                Icon={<FaUser color="#B8B8B8" />}
                labelSize="1.5"
                className="select-dropdown"
                name="gender"
                defaultValue={getIndex(typeGender, editUser?.gender)}
              />
            </FormGroupWithIcon>
          </FormGroupsWrapper>
          <FormGroupsWrapper>
            <FormGroup topMargin="4" width="40" className="formGroup">
              <Button
                bgColor="#A77B37"
                hoverBgColor="#712126"
                hoverColor="#fff"
                style={{ width: "100%" }}
                onClick={handleOpenModal}
                fontWeight="500"
              >
                Edit User
              </Button>
            </FormGroup>
          </FormGroupsWrapper>
        </div>
      </CustomContainer>
    </CustomContainer>
  );
};
export default utility.routeData(
  "edit-profile",
  "Edit Profile",
  <EditProfile />
);
